import App from "../../../core/src/App";
import GameEvents from "../../../core/src/const/GameEvents";
import Layout from "../../../core/src/utils/Layout";
import HTMLPopup from "../../../core/src/views/components/HTMLPopup";

export default class HistoryHTMLPopup extends HTMLPopup {
    protected container: HTMLElement;
    protected btnClose: HTMLButtonElement;
    constructor(htmlContent: string, cb?: Function) {

        super(htmlContent);

        this.container = document.createElement("div");
        this._content = document.createElement("div");
        //@ts-ignore
        let image = htmlContent?.data
        this._content.innerHTML = "<img src=" + image + ">";
        this._content.classList.add("wiener_history_popup");
        this.btnClose = document.createElement("button");
        this.btnClose.setAttribute("class", "wiener_history_btn_close");
        let btnSpan = document.createElement("span");
        btnSpan.innerHTML = "&times";
        btnSpan.setAttribute("class", "wiener_history_btn_span");
        this.btnClose.appendChild(btnSpan);
        this.container.appendChild(this._content);
        this.container.appendChild(this.btnClose);
        this.container.setAttribute("class", "wiener_history_container");
        this.container.style.height = Layout.deviceHeight + "px";

        App.dispatcher.removeListener(GameEvents.RESIZE, this.fitContainer);
        App.dispatcher.addListener(GameEvents.RESIZE, this.fitContainer.bind(this));

        this.btnClose.onclick = () => {
            cb();
        }
    }

    public fitContainer() {
        this.container.style.height = Layout.deviceHeight + "px";
    }

    public get content() {
        return this.container;
    }
}